// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2g7Zp","label":"Radio_label__3P18I","checkMark":"Radio_checkMark__3DIgo","disabled":"Radio_disabled__n2dDC"};